export const statusOption = [
    { value: 0, label: 'None', background: 'secondary' },
    { value: 1, label: 'Started', background: 'info' },
    { value: 2, label: 'Ended', background: 'warning' },
    { value: 3, label: 'Disabled', background: 'danger' }
];
